import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function createNewMinorPatient({
  minorPatient,
  guardian,
  guardianIsBillingUser,
  guardianRelationship,
  minorPatientUserId,
  guardianUserId,
}: {
  minorPatient: ClientPortalPatient;
  guardian?: ClientPortalPatient;
  guardianIsBillingUser: boolean;
  guardianRelationship: string;
  minorPatientUserId?: string | null;
  guardianUserId?: string | null;
}) {
  const response = await fetchOrchidAPI(
    "/api/users/v1/create_patient/minor_and_guardian",
    {
      method: "POST",
      body: JSON.stringify({
        minor_patient_in: minorPatient,
        guardian_in: guardian,
        minor_patient_user_id: minorPatientUserId,
        guardian_user_id: guardianUserId,
        guardian_is_billing_user: guardianIsBillingUser,
        guardian_relationship: guardianRelationship,
      }),
    },
  );

  if (!response.ok) {
    const responseText = await response.text();
    throw new Error(getErrorDetail(responseText));
  }

  return response.json();
}
